module.exports = __webpack_public_path__ + "img/logo-DISE-tmp.6c32f7bc.svg";